import type { ReactNode } from "react";
import { Button, Sheet } from "../../components/ui";
import { IconHeartOutline, IconHeartSolid } from "../../components/Icons";
import "../pages.css";

export interface MemoryFragmentContent {
  title: string | null;
  summary: string | null;
  tags: readonly string[];
}

/**
 * 本地会话与站外相遇共用的“查看记忆碎片”入口和内容层。
 * 记忆来源不同，但标题、关键词与摘要的产品语义完全相同，不应各画一套。
 */
export function MemoryFragmentViewer({
  memory,
  open,
  showTitle = false,
  action,
  onOpen,
  onClose,
}: {
  memory: MemoryFragmentContent;
  open: boolean;
  showTitle?: boolean;
  action?: ReactNode;
  onOpen: () => void;
  onClose: () => void;
}) {
  return (
    <>
      <div className="diary-cta">
        <Button tone="primary" onClick={onOpen}>
          <IconHeartOutline size={15} />
          点击查看记忆碎片
          <IconHeartOutline size={15} />
        </Button>
      </div>

      <Sheet
        open={open}
        title={
          <>
            <IconHeartSolid size={16} />
            记忆碎片
            <IconHeartSolid size={16} />
          </>
        }
        label="记忆碎片"
        onClose={onClose}
      >
        <article className="fragment">
          {showTitle && memory.title ? (
            <h3 className="diary__title">{memory.title}</h3>
          ) : null}

          {memory.tags.length > 0 ? (
            <div className="fragment__tags">
              {memory.tags.map((tag) => (
                <span key={tag} className="chip chip--brand">
                  {tag}
                </span>
              ))}
            </div>
          ) : null}

          {memory.summary ? (
            <p className="fragment__summary">{memory.summary}</p>
          ) : (
            <p className="inline-hint">她记下了这几个词，还没写下别的。</p>
          )}

          {action}
        </article>
      </Sheet>
    </>
  );
}
